var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.overlay)?_c('div',{staticClass:"overlay"},[_c('div'),_c('b-spinner'),_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.overlayLogo,"alt":"Lalak"}})],1):_vm._e(),(!_vm.overlay)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }